var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"white--text ml-5",attrs:{"color":"primary"},on:{"click":_vm.exportDoc}},[_vm._v(" EXPORT "),_c('img',{attrs:{"src":require('@/assets/image/Tra-Khrut-JPEG.jpg'),"alt":"","hidden":"","id":"imgsrc"}})])}
var staticRenderFns = []

export { render, staticRenderFns }